import React from "react";
import SvgLines from "react-mt-svg-lines";

export default function Image({ content, singleScreenStep, page }) {
  if (content.two_images) {
    return (
      <div
        className={`content-image ${page}`}
        style={{
          position: "relative",
          transformOrigin: content.transform_origin
            ? content.transform_origin
            : null,
          // height: `${content.height + content.height2}px`,
          width: "auto",
        }}
      >
        <img
          alt="tv-screen"
          src={content.src}
          style={{
            height: `${content.height}px`,
            width: "auto",
            transformOrigin: content.transform_origin
              ? content.transform_origin
              : null,
            margin: content.margin ? content.margin : null,
            animation:
              content.svg === "mr-ov" ? "1s slideDown forwards" : "none",
          }}
        />
        <img
          alt="tv-screen"
          src={content.src2}
          style={{
            height: `${content.height2}px`,
            width: "auto",
            margin: content.margin ? content.margin2 : null,
            animation:
              content.svg === "mr-ov" ? "1s slideDown forwards" : "none",
          }}
        />
      </div>
    );
  } else {
    return (
      <div
        className={`content-image ${page}`}
        style={{
          opacity: content.svg === "epg" ? 0 : 1,
          animation: content.svg === "epg" ? "1s fadeIn 0.3s forwards" : "none",
          margin: content.component_margin,
          // height: `${content.height}px`,
          width:
            content.meta && content.meta === "sound"
              ? "100% !important"
              : "100%",

          position: "relative",
          transformOrigin: content.transform_origin
            ? content.transform_origin
            : null,
        }}
      >
        {content.meta && content.meta === "sound" ? (
          <img
            alt="sound"
            className="denyTransform"
            src={content.src}
            style={{
              height: "auto",
              width: "95%",
              position: "absolute",
              zIndex: "199",
              top: content.top ? content.top : null,
              left: content.left ? content.left : null,
              margin: content.margin ? content.margin : null,
              animation:
                content.svg === "mr-ov" ? "1s slideDown forwards" : "none",
            }}
          />
        ) : (
          <img
            alt="tv-screen"
            src={content.src}
            className={content.push_left ? "alter-position-left" : null}
            style={{
              height: content.bezel
                ? `calc(${content.height} * 0.895px)`
                : `${content.height}px`,
              width: "auto",
              position: "absolute",
              zIndex: "199",
              top: content.top ? content.top + 9 : null,
              left: content.left ? content.left : null,
              margin: content.margin ? content.margin : null,

              animation:
                content.svg === "mr-ov" ? "1s slideDown forwards" : "none",
            }}
          />
        )}
        {content.black_screen ? (
          <img
            className={content.push_left ? "alter-position-left" : null}
            alt="power-off"
            src="/application/webos/webos_tv_emulator/images/emulator/power-off-2.png"
            style={{
              position: "absolute",
              top: content.top,
              left: content.left,
              height: content.bezel
                ? `calc(${content.height} * 0.89px)`
                : `${content.height}px`,
              width: "auto",
              zIndex: "190",
            }}
          />
        ) : null}
        {content.svg === "mr-ov" ? (
          <>
            <SvgLines animate={1000} stagger={150} duration={3000}>
              {/* <img
            alt="callouts"
            src="/application/webos/webos_tv_emulator/images/thinq-logo-3.svg"
            style={{
              height: content.bezel
                ? `calc(${content.height} * 0.89px)`
                : `${content.height}px`,
              width: "auto",
              position: "absolute",
              zIndex: "200",
              top: content.top ? content.top : "0px",
              left: content.left ? content.left : "-182px",
            }}
          /> */}
              <svg
                style={{
                  height: "850",
                  width: "636",
                  position: "absolute",
                  zIndex: "200",
                  top: content.top ? content.top : "-21px",
                  left: content.left ? content.left : "-188px",
                }}
              >
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M165,188.1h34.7l91.9,151.1"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M303,393.8h-2c-11.5,0-18.9-9.4-18.9-20.9v-14.4c0-11.5,7.4-20.9,18.9-20.9h2c11.5,0,18.9,9.4,18.9,20.9v14.4C321.9,384.4,314.5,393.8,303,393.8z"
                />

                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M129.1,330.5h61.4l157.2,242.3"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M382.7,595.2c0,12.6-10.2,22.8-22.8,22.8
	c-12.6,0-22.8-10.2-22.8-22.8c0-12.6,10.2-22.8,22.8-22.8C372.4,575.3,382.7,575.5,382.7,595.2z"
                />

                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M129.1,486.5h49.1l56.2,90.3"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M269.3,595.2c0,12.6-10.2,22.8-22.8,22.8
	c-12.6,0-22.8-10.2-22.8-24.8c0-13.6,10.2-22.8,22.8-22.8C259.1,575.3,269.3,575.5,269.3,595.2z"
                />
                <circle
                  fill="#BF0C3F"
                  cx="169.4"
                  cy="188.1"
                  r="7.4"
                  style={{
                    opacity: "0",
                    animation: "0.5s 0.5s 1 normal forwards load-this",
                  }}
                />
                <circle
                  fill="#BF0C3F"
                  cx="134.5"
                  cy="330.5"
                  r="7.4"
                  style={{
                    opacity: "0",
                    animation: "0.5s 1.6s 1 normal forwards load-this",
                  }}
                />
                <circle
                  fill="#BF0C3F"
                  cx="134.5"
                  cy="486.5"
                  r="7.4"
                  style={{
                    opacity: "0",
                    animation: "0.5s 2.5s 1 normal forwards load-this",
                  }}
                />
              </svg>
            </SvgLines>
            <img
              alt="callouts"
              src="/application/webos/webos_tv_emulator/images/thinq-logo-3.svg"
              style={{
                height: "80px",
                width: "auto",
                position: "absolute",
                zIndex: "200",
                top: "125px",
                left: "-270px",
                filter: "drop-shadow(3px 5px 8px rgb(0 0 0 /0.7))",
                opacity: "0",

                animation: "0.5s 0.5s 1 normal forwards load-this",
              }}
            />
            <img
              src="/application/webos/webos_tv_emulator/images/provider-icons/prime-video-tv-icon.svg"
              alt=""
              style={{
                height: "120px",
                width: "auto",
                position: "absolute",
                zIndex: "200",
                top: "250px",
                left: "-220px",
                filter: "drop-shadow(3px 5px 8px rgb(0 0 0 /0.7))",
                opacity: "0",
                animation: "0.5s 1.6s 1 normal forwards load-this",
              }}
            />
            <img
              src="/application/webos/webos_tv_emulator/images/provider-icons/netflix-tv-icon.svg"
              alt=""
              style={{
                height: "120px",
                width: "auto",
                position: "absolute",
                zIndex: "200",
                top: "410px",
                left: "-220px",
                filter: "drop-shadow(3px 5px 8px rgb(0 0 0 /0.7))",
                opacity: "0",
                animation: "0.5s 2.5s 1 normal forwards load-this",
              }}
            />
          </>
        ) : null}
        {content.bezel ? (
          <img
            className={content.push_left ? "alter-position-left" : null}
            alt="bezel"
            src={content.bezel}
            style={{
              height: `${content.height}px`,
              width: "auto",
              position: "absolute",
              top: content.top,
              left: content.left,
              zIndex: "200",
            }}
          />
        ) : null}
        {content.animated_icons ? (
          <>
            {/* <img
            src="/application/webos/webos_tv_emulator/images/provider-icons/netflix-tv-icon.svg"
            alt=""
            style={{
              position: "absolute",
              zIndex: "201",
              height: "64px",
              width: "64px",
              top: "calc(50% + 37px)",
              left: "calc(50% - 312px)",
              opacity: "0",
              filter: "drop-shadow(3px 5px 5px rgb(0 0 0 / 1))",
              animation: "0.3s ease 0.8s normal forwards providerYoutube",
            }}
          />
          <img
            src="/application/webos/webos_tv_emulator/images/provider-icons/prime-video-tv-icon.svg"
            alt=""
            style={{
              position: "absolute",
              zIndex: "201",
              height: "80px",
              width: "80px",
              top: "calc(50% - 50px)",
              left: "calc(50% - 229px)",
              opacity: "0",
              filter: "drop-shadow(3px 5px 8px rgb(0 0 0 / 1))",
              animation: "0.3s ease 1.1s 1 normal forwards  providerPrime",
            }}
          />
          <img
            src="/application/webos/webos_tv_emulator/images/provider-icons/youtube-tv-icon.svg"
            alt=""
            style={{
              position: "absolute",
              zIndex: "201",
              height: "100px",
              width: "100px",
              top: "calc(50% - 150px)",
              left: "calc(50% - 125px)",
              opacity: "0",
              filter: "drop-shadow(3px 5px 8px rgb(0 0 0 / 1))",
              animation: "0.3s ease 1.4s 1 normal forwards providerYT",
            }}
          /> */}
          </>
        ) : null}
      </div>
    );
  }
}
